/* Opens the inline privacy policy. Native <dialog>, so the top layer, the
   backdrop and Escape are the platform's, not ours. Focus is moved to the
   close control on open and returned to the opener on close. */
(function () {
  function bind(root) {
    (root || document).querySelectorAll('[data-policy-open]').forEach(function (btn) {
      if (btn.dataset.policyBound === '1') return;
      btn.dataset.policyBound = '1';
      btn.addEventListener('click', function () {
        var dlg = document.getElementById('policy-' + btn.getAttribute('data-policy-open'));
        if (!dlg) return;
        var opener = btn;
        if (typeof dlg.showModal === 'function') dlg.showModal();
        else dlg.setAttribute('open', '');
        var close = dlg.querySelector('[data-policy-close]');
        if (close) close.focus();
        function onClose() {
          dlg.removeEventListener('close', onClose);
          if (opener && document.contains(opener)) opener.focus();
        }
        dlg.addEventListener('close', onClose);
        if (close && close.dataset.bound !== '1') {
          close.dataset.bound = '1';
          close.addEventListener('click', function () { dlg.close(); });
        }
        if (dlg.dataset.bound !== '1') {
          dlg.dataset.bound = '1';
          /* Click on the backdrop = click on the dialog element itself. */
          dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(); });
  else bind();
  document.addEventListener('cm:product-hydrated', function () { bind(); });
  window.CMPolicyDialog = { bind: bind };
})();
